function getDateDiffDelay(dateDelay) {
        var dateAttr = dateDelay.split('.');
        dateDelay = new Date(dateAttr[2], dateAttr[1] - 1, (dateAttr[0]));
        var today = new Date();
        var daysDiff = Math.ceil((today.getTime() - dateDelay.getTime()) / (1000 * 3600 * 24));
        return daysDiff;
    }

export {getDateDiffDelay}